import { render, staticRenderFns } from "./IconUpArrow.vue?vue&type=template&id=96ba131e&scoped=true"
import script from "./IconUpArrow.vue?vue&type=script&lang=js"
export * from "./IconUpArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ba131e",
  null
  
)

export default component.exports